import React, { Component } from 'react';
import { connect } from "react-redux";
import {Modal } from 'reactstrap';
import TermsAndConditions from 'components/common/Modals/EmployeeLicenseTerms';
import Footerlogo from 'Assets/images/green-trane-BA-logos.svg';
import styles from './shared.module.css';
import { getCommonResources_Action } from 'action/cultureAction';

class Footer extends Component {

    async componentWillMount() {
        const l_Request =  this.props.getCommonResources_Action();
        await Promise.all([l_Request]);
    }

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };
        this.toggle = this.toggle.bind(this);
        this.CloseModal = this.toggle.bind(this);
    }

    toggle() { this.setState({ modal: !this.state.modal })}
    CloseModal (data){ if (data === "Cancel") {  this.toggle()} }

    render(Common_Resource_from_Store) {
        let label = (this.props.Common_Resource_from_Store !== undefined && this.props.Common_Resource_from_Store !== null) ? this.props.Common_Resource_from_Store : [] ;
        return (
            <div className={styles.footer}>
            <hr className={styles.footer_line} />
                <div className={styles.footer_content}  >
                    <div className={styles.footer_text_container}>
                        <p className={styles.footer_text}>{label["FacilityRequests.Text"] !== undefined ? label["FacilityRequests.Text"] : "Facility Requests"}</p>
                        <p className={styles.footer_text}>{label["footer.copyright.Text"] !== undefined ? label["footer.copyright.Text"] : "© 2021 Trane" }{" | "}<span className={styles.footer_link}>{label["PrivacyPolicy.Text"] !== undefined ? label["PrivacyPolicy.Text"] : "Privacy Policy" }  </span> | <span className={styles.footer_link}  onClick={this.toggle}> Terms of Use </span></p>
                        {/* <p className={styles.footer_text}>Ingersoll Rand</p> */}
                    </div>

                    <div className={styles.footer_logo_container}>
                    <img src={Footerlogo} alt="Trane Logo"  className={styles.footer_logo}/> 
                    </div>

                </div>

                 <Modal isOpen={this.state.modal} className="emp_license_modal"  >   {/*Terms and Conditions Popup */}
                    <TermsAndConditions CloseModal={this.CloseModal} />
                </Modal>
            </div>
            
        );
    }
}

const mapStateToProps = state => {
    return {
        Common_Resource_from_Store: state.CommonResourceDataRootReducer.CommonResourcesData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
       getCommonResources_Action: () => dispatch(getCommonResources_Action()),
    };
}; 

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
